import React, { useState, useEffect, useRef } from 'react';
import { FjTooltip } from '../fj-tooltip';
import './index.css';

type OverflowProps = {
  children: React.ReactElement;
};

const Overflow = React.forwardRef<HTMLDivElement, OverflowProps>((props: OverflowProps, ref) => (
  <div ref={ref} className="ellipsis">
    {props.children}
  </div>
));

type FjEllipsisProps = {
  children: React.ReactElement;
};

const FjEllipsis: React.FC<FjEllipsisProps> = ({ children }: FjEllipsisProps) => {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const elRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (elRef.current) {
        const isOverflow = elRef.current.clientWidth < elRef.current.scrollWidth;
        setIsOverflowing(isOverflow);
      }
    });

    if (elRef.current) {
      resizeObserver.observe(elRef.current);
    }

    return () => {
      if (elRef.current) {
        resizeObserver.unobserve(elRef.current);
      }
    };
  }, []);

  return (
    <Overflow ref={elRef}>
      <FjTooltip Component={children} override={!isOverflowing}>
        {children}
      </FjTooltip>
    </Overflow>
  );
};

export default FjEllipsis;
